import { toObject } from "../../core/utils";
import assign from "lodash/fp/assign";
import keys from "lodash/fp/keys";
import values from "lodash/fp/values";
import zipWith from "lodash/fp/zipWith";
import map from "lodash/fp/map";
import flow from "lodash/fp/flow";
import identity from "lodash/fp/identity";

class CompanyPageTransform {
  constructor() {
    "ngInject";

    this.captainsFields = [
      { title: "Name", name: "name" },
      { title: "Phone", name: "phone" },
      { title: "Status", name: "status" },
      { title: "Rating", name: "rating" },
    ];

    this.busesFields = [
      { title: "Type", name: "type" },
      { title: "Plates", name: "plates" },
    ];
  }

  justify(data) {
    const formatDocuments = (item) => {
      const documentsData = {};
      documentsData.owner = item.owner || {};
      documentsData.owner.national_id = assign(
        { isDisabled: true },
        documentsData.owner.national_id
      );
      documentsData.documents = item.documents || {};
      documentsData.documents.commercial_registration = assign(
        { isDisabled: true },
        documentsData.documents.commercial_registration
      );
      documentsData.documents.insurance_number = assign(
        { isDisabled: true },
        documentsData.documents.insurance_number
      );
      documentsData.documents.tax_number = assign(
        { isDisabled: true },
        documentsData.documents.tax_number
      );

      item.documentsData = documentsData;

      return item;
    };
    data.is_tax_filer = { name: data.is_tax_filer };
    data.owner = toObject(data.owner);
    data.extraInfo = this.justifyExtraInfo(data.extra_info);
    data.managers = data.managers || [];

    return toObject(flow([formatDocuments, identity])(data));
  }

  justifyExtraInfo(info) {
    const infoKeys = keys(info);
    const infoValues = values(info);

    return zipWith((key, value) => ({ key, value }), infoKeys, infoValues);
  }

  justifyCaptains(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const format = (item) => {
      item.rating = item.rating.toFixed(2);

      return item;
    };

    return map(flow([getSource, format]))(data);
  }

  justifyBuses(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);

    return map(getSource)(data);
  }
}

export default CompanyPageTransform;



// WEBPACK FOOTER //
// ./src/pages/company/company.transforms.js